import { createFileRoute } from '@tanstack/react-router';
import { Dashboard } from '../../../components/Dashboard';

export const Route = createFileRoute('/app/dashboard/')({
  component: DashboardPage,
});

function DashboardPage() {
  return <Dashboard />;
}